import React, { useMemo } from "react";
import "./Confetti.css";

// Petite animation de célébration (sans dépendance externe) déclenchée après
// l'envoi réussi d'une participation. Purement décorative, ne bloque rien.

const COULEURS = ["#099AD9", "#C1195F", "#3BB6A3", "#DDDC02", "#F2920A"];
const NOMBRE_PIECES = 60;

export default function Confetti() {
  const pieces = useMemo(() => {
    return Array.from({ length: NOMBRE_PIECES }).map((_, i) => ({
      id: i,
      left: Math.random() * 100,
      delay: Math.random() * 0.4,
      duration: 2 + Math.random() * 1.5,
      color: COULEURS[i % COULEURS.length],
      rotate: Math.random() * 360,
      width: 6 + Math.random() * 6,
    }));
  }, []);

  return (
    <div className="confetti-container" aria-hidden="true">
      {pieces.map((p) => (
        <span
          key={p.id}
          className="confetti-piece"
          style={{
            left: `${p.left}%`,
            backgroundColor: p.color,
            width: p.width,
            height: p.width * 0.4,
            animationDelay: `${p.delay}s`,
            animationDuration: `${p.duration}s`,
            transform: `rotate(${p.rotate}deg)`,
          }}
        />
      ))}
    </div>
  );
}
